export const matchesCategory = (profile, activeTagId) => {
	if (activeTagId === 'all') {
		return true;
	}

	const tagIds = new Set(
		[
			...(profile.tags || []).map((tag) => tag?._id?.toString()),
			...(profile.tag || []).map((tag) => tag?._id?.toString()),
			...(profile.tag_ids || []).map((id) => id?.toString()),
		].filter(Boolean),
	);

	return tagIds.has(activeTagId);
};
